
import { Routes, Route, useSearchParams, useLocation } from 'react-router-dom';
import LoginPage from "./pages/LoginPage";
import HomePage from './pages/HomePage';
import UserPage from './pages/UserPage';
import RegisterDevice from './pages/RegisterDevice';
import TenantPage from './pages/TenantPage';
import HolidayPage from './pages/HolidayPage';
import PersonPage from './pages/PersonPage';
import VehiclePage from './pages/VehiclePage';
import LogPage from './pages/LogPage';
import RateWizard from './pages/RateWizard';
import RatePage from './pages/RatePage';
import PrivateRoute from './components/PrivateRoute';
import ProtectedRouteByPermission from './components/ProtectedRouteByPermission';
import ResetPasswordModal from './components/ResetPassword';
import AppNavbar from './components/Navbar';
import "bootstrap/dist/css/bootstrap.min.css";
import SystemSetting from './pages/SystemSetting';
import PlacesGeoRef from './pages/PlacesGeoRef';
import MonitorPage from './pages/MonitorPage';

function App() {

  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const token = searchParams.get('token');
  const showResetModal = Boolean(email && token);
  const location = useLocation();
  const hideNavbar = location.pathname === '/';

  return (
    <>
      {!hideNavbar && <AppNavbar />}
      <div  style={{ maxWidth: '100%' }}>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/home" element={<PrivateRoute><HomePage /></PrivateRoute>} />
          <Route
            path="/users"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="users.view">
                  <UserPage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />

          <Route
            path="/tenants"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="tenants.view">
                  <TenantPage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/holidays"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="">
                  <HolidayPage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/system_settings"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="">
                  <SystemSetting />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/places_geo_ref"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="">
                  <PlacesGeoRef />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/persons"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="persons.view">
                  <PersonPage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/vehicles"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="vehicles.view">
                  <VehiclePage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="logs.view">
                  <LogPage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/monitor"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="reports.view">
                  <MonitorPage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route
            path="/rates"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="rates.create">
                  <RatePage />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route path="register-device" element={<RegisterDevice />} />
          <Route
            path="/rates/new"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="rates.create">
                  <RateWizard />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />

          <Route
            path="/rates/:rateId/wizard"
            element={
              <PrivateRoute>
                <ProtectedRouteByPermission permission="rates.create">
                  <RateWizard />
                </ProtectedRouteByPermission>
              </PrivateRoute>
            }
          />
          <Route path="register-device" element={<RegisterDevice />} />

        </Routes>
      </div>

      <ResetPasswordModal show={showResetModal} handleClose={() => window.history.replaceState({}, '', '/')} />
    </>
  );
}

export default App;
